import {IStore, useStore} from "@ui/stores"
import DownMenu from "./Down"
import LeftMenu from "./Left"
import {ReactElement} from "react"

export enum MenuItem {
	Track,
	Profile,
  Route,
	Adapter,
	Neighbour,
  Friends,
  Sos,
  Poi,
  Layer
}

export type TMenuItem = {
  item: MenuItem
  icon?: ReactElement<{disabled?: boolean}>
  title: string
  selected?: (store: IStore) => boolean
  disabled?: boolean
}

export type MenuItemProps = {
  open: () => void
	close: () => void
	isShow: boolean
}

export type TMenuProps = {
  onCLick: (item: MenuItem) => void
  selected?: MenuItem
}

const Menu = ({...props}: TMenuProps) => {
  const {settings} = useStore()

  return settings.isDesktop ? <LeftMenu {...props} /> : <DownMenu {...props} />
}

export default Menu
